import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const append = (source, element) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 1: {
            const generator = () => {
                const array = dataFunc.generator();
                array.push(Promise.resolve(element));
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 2: {
            const generator = async () => {
                const array = await dataFunc.generator();
                array.push(Promise.resolve(element));
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 0: {
            const generator = async () => {
                const array = await dataFunc.generator();
                array.push(element);
                return array;
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
    }
};
